'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _starRating = require('star-rating');

var _profileHeader = require('../../src/styles/profile-header.scss');

var _profileHeader2 = _interopRequireDefault(_profileHeader);

var _specialistProfileHeader = require('../../src/styles/specialist-profile-header.scss');

var _specialistProfileHeader2 = _interopRequireDefault(_specialistProfileHeader);

var _practiceProfileHeader = require('../../src/styles/practice-profile-header.scss');

var _practiceProfileHeader2 = _interopRequireDefault(_practiceProfileHeader);

var _profileBadge = require('../../../profile-badge');

var _specialtySvgIcon = require('../../../specialty-svg-icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns an array of React elements with the photos in the photo roll.
 * @param {!Array<string>} photos A list of photo URLs.
 * @return {!Array<symbol>} React elements with the photos in the photo roll.
 */
var getPhotoRoll = function getPhotoRoll(photos) {
  var photoRoll = [];
  (photos || []).forEach(function (photo) {
    photoRoll.push(_react2.default.createElement(
      'span',
      null,
      _react2.default.createElement('img', { src: photo })
    ));
  });
  return photoRoll;
};

var ProfileHeader = function ProfileHeader(props) {
  var photoRoll = props.type === 'practice' ? getPhotoRoll(props.photos) : [];

  var backgroundStyles = props.backgroundImage ? {
    backgroundImage: props.isCore && 'url(' + props.backgroundImage + ')'
  } : {};

  var profileImage = props.profileImage || props.specialtyIcon || '/static/img/specialty-icons/default_specialty_icon.png';
  var name = props.name + (props.networks && props.networks.length && '.' || '');

  var shouldRenderSvg = profileImage && profileImage.includes('specialty-icons') || false;

  var showBadge = props.isCore || props.videoConsultation;

  return _react2.default.createElement(
    'div',
    {
      className: _profileHeader2.default.headerContainer + ' ' + (props.backgroundImage ? _practiceProfileHeader2.default.imageCover : '') + ' ' + props.className,
      style: backgroundStyles },
    showBadge && _react2.default.createElement(
      'div',
      { className: _profileHeader2.default.profileBadgeContainer },
      _react2.default.createElement(_profileBadge.ProfileBadge, { isCore: props.isCore, isVideoConsultation: props.videoConsultation })
    ),
    _react2.default.createElement(
      'div',
      {
        className: _profileHeader2.default.innerContainer + ' ' + (props.backgroundImage || photoRoll.length ? _practiceProfileHeader2.default.foreground : '') },
      _react2.default.createElement(
        'div',
        { className: _profileHeader2.default.profileImageContainer },
        _react2.default.createElement(
          'div',
          { className: props.isCore && _profileHeader2.default.profileImageWrapper || _profileHeader2.default.nonCoreWrapper },
          shouldRenderSvg && _react2.default.createElement(
            'div',
            { className: _profileHeader2.default.specialtyIconImageWrapper },
            _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
              specialtyIconUri: profileImage,
              className: _profileHeader2.default.profileImageSpecialtyIcon
            })
          ) || _react2.default.createElement('img', {
            className: _profileHeader2.default.profileImage,
            src: profileImage,
            alt: name
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: _profileHeader2.default.rightColumn + '  ' + (showBadge ? _profileHeader2.default.rightColumnBadge : '') },
        props.name && _react2.default.createElement(
          'div',
          { className: _profileHeader2.default.title },
          _react2.default.createElement(
            'div',
            { id: _profileHeader2.default.name },
            name
          ),
          props.qualifications && _react2.default.createElement(
            'div',
            { id: _specialistProfileHeader2.default.qualifications },
            props.qualifications
          )
        ),
        props.specialty && _react2.default.createElement(
          'div',
          { id: _specialistProfileHeader2.default.specialty },
          props.specialtyIcon && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
            specialtyIconUri: props.specialtyIcon,
            className: _specialistProfileHeader2.default.specialtyIcon
          }),
          _react2.default.createElement(
            'span',
            null,
            props.specialty
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { id: _profileHeader2.default.stars, onClick: props.onStarsClick,
              title: props.averageRating + ' stars' },
            _react2.default.createElement(_starRating.StarRating, { averageRating: props.averageRating })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              props.totalReviews ? props.totalReviews : 'No',
              ' ',
              props.totalReviews === 1 ? 'review' : 'reviews'
            )
          )
        ),
        props.children
      )
    ),
    photoRoll && _react2.default.createElement(
      'div',
      { className: _practiceProfileHeader2.default.photos },
      _react2.default.createElement(
        'div',
        { className: _practiceProfileHeader2.default.innerContainer },
        photoRoll
      )
    )
  );
};

ProfileHeader.propTypes = {
  type: require('react').PropTypes.string.isRequired,
  name: require('react').PropTypes.string.isRequired,
  qualifications: require('react').PropTypes.string.isRequired,
  specialty: require('react').PropTypes.string.isRequired,
  profileImage: require('react').PropTypes.string.isRequired,
  profileImageBackground: require('react').PropTypes.string.isRequired,
  specialtyIcon: require('react').PropTypes.string.isRequired,
  averageRating: require('react').PropTypes.number.isRequired,
  totalReviews: require('react').PropTypes.number.isRequired,
  backgroundImage: require('react').PropTypes.string.isRequired,
  photos: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired,
  onStarsClick: require('react').PropTypes.func.isRequired,
  onAddReview: require('react').PropTypes.func.isRequired,
  children: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  className: require('react').PropTypes.string.isRequired,
  isCore: require('react').PropTypes.bool.isRequired,
  isAHG: require('react').PropTypes.bool.isRequired,
  videoConsultation: require('react').PropTypes.bool.isRequired,
  networks: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired
};
ProfileHeader.displayName = 'ProfileHeader';

ProfileHeader.defaultProps = {
  averageRating: 0,
  totalReviews: 0
};

exports.default = ProfileHeader;


// WEBPACK FOOTER //
// ./components/profile-header/lib/components/profile-header.js